import React from 'react';
import { CalendarProgressMobile } from './CalendarProgress';
import { getJourneyProfileInfo } from './CalendarPage';
import { Typography, makeStyles, CardContent, Card } from '@material-ui/core';
import { styleBreakDesktop } from '../utilities/layouts/Globals';
import { useHistory } from 'react-router-dom';
import { PATH_CALENDAR } from '../../containers/RoutePaths';

const useStyles = makeStyles(theme => ({
    yourJourneyTitle: {
        marginTop: theme.spacing(3.75),
        marginBottom: theme.spacing(1),
        [styleBreakDesktop(theme)]: {
            marginTop: theme.spacing(7.5),
            marginBottom: theme.spacing(2),
        },
    },
    stageLabel: {
        marginBottom: theme.spacing(1.5),
        fontWeight: 600,
    },
    yourJourneycard: {
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.25)',
        borderRadius: '5px',
        marginBottom: theme.spacing(3),
        cursor: 'pointer',
    },
    cardContent: {},
    cardContentRoot: {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(0),
        '&:last-child': {
            paddingBottom: theme.spacing(3),
        },
    },
    timelineProgressBar: {
        position: 'relative',
        width: '100%',
    },
}));

export default function YourJourneyComponent({ visits, patientDiagnosisDate }) {
    const classes = useStyles();
    const history = useHistory();
    const { seminomaLabel, dateOfDiagnosis, endOfTreatementDate } = getJourneyProfileInfo(visits, patientDiagnosisDate);

    const onCardClick = e => {
        e.preventDefault();
        history.push(PATH_CALENDAR);
    };

    return (
        <>
            <Typography data-cy="label_your_journey" variant="h2" className={classes.yourJourneyTitle}>
                Your Journey
            </Typography>
            <Card data-cy="card_your_journey" className={classes.yourJourneycard} onClick={onCardClick}>
                <CardContent
                    classes={{
                        root: classes.cardContentRoot,
                    }}
                    className={classes.cardContent}
                >
                    <Typography variant="body1" className={classes.stageLabel}>
                        {seminomaLabel}
                    </Typography>
                    <CalendarProgressMobile
                        dateOfDiagnosis={dateOfDiagnosis}
                        endOfTreatmentDate={endOfTreatementDate}
                        timelineProgressBarClass={classes.timelineProgressBar}
                        useDefaultColor={true}
                        noBottomMarginStartEndContainer={true}
                    />
                </CardContent>
            </Card>
        </>
    );
}
